import { RestSlice } from '../../../../../redux/rest.slice';
import { IppSampleImportTemplate } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippSampleImportTemplateSlice = new RestSlice<IppSampleImportTemplate>(
	localizationService.getLocalizedString('ipp.sampleImportTemplateList.pageHeading'),
	Resource.IppSampleFlowTemplate
);
export default ippSampleImportTemplateSlice.rests.reducer;
